import React from 'react';

export const HiringAndPromotionCopilotWrapper = ({
  chart,
  slate,
}: {
  chart: React.ReactNode;
  slate: React.ReactNode;
}) => {
  return (
    <div className="flex flex-row justify-between gap-2">
      <div className="w-[865px]">{chart}</div>
      <div className={'max-w-[500px] min-w-[350px] flex-1'}>{slate}</div>
    </div>
  );
};
